import React from 'react';
import { Grid } from '@material-ui/core';
import { shape } from 'prop-types';

import { FormSelect, FormTextField, MultiSelect } from '../../../../../components';

import {
  APP_APIS_LIST_STATES_FILTER_OPTIONS,
} from '../../../../../constants';

export const FilterByApiName = (props) => (
  <Grid item md={3}>
    <FormTextField
      {...props}
      id="app-product-apis-filter-by-apiName"
      data-apim-test="app-product-apis-filter-by-apiName"
    />
  </Grid>
);

export const FilterByTags = (props) => (
  <Grid item md={3} className={props.fieldContainerClass}>
     <MultiSelect
      {...props}
      id="app-product-apis-filter-by-tags"
      data-apim-test="app-product-apis-filter-by-tags"
    />
  </Grid>
);

FilterByTags.propTypes = {
  fieldContainerClass: shape({}),
};

export const FilterByStates = (props) => (
  <Grid item md={2}>
    <FormSelect
      {...props}
      id="app-product-apis-filter-state-by"
      data-apim-test="app-product-apis-filter-state-by"
      data={APP_APIS_LIST_STATES_FILTER_OPTIONS}
      noNoneOption
      noNativeSelect
    />
  </Grid>
);


export const FilterAndSortSeparator = () => (
  <Grid item md={4} />
);
